import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM, Title2 } from '@sorare/core/src/atoms/typography';
import Dialog from '@sorare/core/src/components/dialog';
import { useOneTimeDialogContext } from '@sorare/core/src/contexts/oneTimeDialog';
import { OneTimeDialog } from '@sorare/core/src/contexts/oneTimeDialog/Provider';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { glossary } from '@sorare/core/src/lib/glossary';

const Body = styled(Vertical).attrs({ gap: 4, center: true })`
  padding: var(--quadruple-unit);
  margin: auto;
  justify-content: stretch;
`;
const Subtitle = styled(LabelM)`
  color: var(--c-neutral-700);
`;
const LongLiveTheSquads = () => {
  const {
    flags: { useShowCustomListTuto = false },
  } = useFeatureFlags();
  const { sawDialog } = useOneTimeDialogContext();

  if (!useShowCustomListTuto) {
    return null;
  }

  return (
    <OneTimeDialog
      dialogId={LIFECYCLE.sawNewCustomListTuto}
      show={!sawDialog(LIFECYCLE.sawNewCustomListTuto)}
    >
      {({ onClose, open }) => (
        <Dialog maxWidth="xs" open={open}>
          <Body>
            <Vertical gap={2} className="text-center">
              <Title2>
                <FormattedMessage
                  id="LongLiveTheSquads.title"
                  defaultMessage="The Squad feature has moved"
                />
              </Title2>
              <Subtitle>
                <FormattedMessage
                  id="LongLiveTheSquads.subtitle"
                  defaultMessage="You can now create squad lists directly in your Card Gallery. Your lists will be seen by other Managers visiting your card gallery. You can also use these lists as filters when building your lineups."
                />
              </Subtitle>
            </Vertical>
            <Button onClick={onClose} color="primary" size="medium" fullWidth>
              <FormattedMessage {...glossary.gotIt} />
            </Button>
          </Body>
        </Dialog>
      )}
    </OneTimeDialog>
  );
};

export default LongLiveTheSquads;
